import { AwardNaverIcon, MyStyleIcon } from '@local/assets/icons'
import { extractByTypename } from '@local/utils'

import { usePlaceDetailQuery } from '@web/hooks/usePlaceDetail.federation'

import styles from './PlaceAwards.module.scss'

type Props = {
  placeId: string
}

/**
 * @note Porta PlaceDetail 쿼리 (xbu기반) 사용, 단건조회이므로 목록형노출 지양
 */
const NaverAwards = ({ placeId }: Props) => {
  const { data, loading, error } = usePlaceDetailQuery({ placeId })

  const { PlaceDetail } = extractByTypename(data?.placeDetail)
  if (error || loading || !PlaceDetail) {
    return null
  }

  const [naverBookingAward] = PlaceDetail.bookingAwards ?? []
  const myStyleAward = PlaceDetail.myStyleAwards?.shop

  if (naverBookingAward?.year && naverBookingAward?.award) {
    const displayTitle = `${naverBookingAward.award} ${naverBookingAward.year}`
    return (
      <div className={styles.naver_booking_award_area}>
        <AwardNaverIcon className={styles.icon_award_reserve} aria-hidden="true" />
        {displayTitle}
      </div>
    )
  }

  if (myStyleAward?.year && myStyleAward?.title) {
    const displayTitle = `${myStyleAward.year} ${myStyleAward.title}`
    return (
      <div className={styles.popular_style_area}>
        <MyStyleIcon className={styles.icon} aria-hidden="true" />
        인기스타일 {displayTitle}
      </div>
    )
  }

  return null
}

export default NaverAwards
